import React from 'react';
import AdminNoticeList from '../components/admin/notice/AdminNoticeList';

const AdminNotice = () => {
    return (
        <AdminNoticeList />
    );
};

export default AdminNotice;